import {
	CANDIDATE_CONFIG,
	CANDIDATE_ONBOARDING_CONFIG,
	CANDIDATE_CONFIG_ONBOARD,
	CANDIDATE_ONBOARDING_COMPLETE_CONFIG,
	CANDIDATE_STATUS_WORKFLOW_CONFIG,
	CANDIDATE_STATUS_WORKFLOW_CONFIG_ONLY,
	CANDIDATE_ARCHIVED_REASONS,
} from "../../config/endpoints";
import { HeadersAuth, HeadersNoAuth, HTTP, IHttpResponse } from "./http";
import { ICandidateConfig } from "../../_models/data.candidateConfig.model";
import { ICandidateStatusWorkflow } from "../../_models/data.candidateStatusWorkflow.model";
import { ICandidateArchiveReason } from "../../_models/data.candidateArchivedReasons.model";

export const GetCandidateConfig = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_CONFIG,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateOnboardingConfig = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_ONBOARDING_CONFIG,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateConfigOnboard = (CANDIDATE_ID, Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_CONFIG_ONBOARD(CANDIDATE_ID, Token),
		Headers: HeadersNoAuth,
	}) as Promise<IHttpResponse>;
};

export const UpdateCandidateConfig = (Token: string, DATA: ICandidateConfig) => {
	return HTTP({
		Method: "POST",
		Url: CANDIDATE_CONFIG,
		Data: DATA ?? null,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateOnboardingCompleteConfig = (Token: string, CANDIDATE_ID: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_ONBOARDING_COMPLETE_CONFIG(CANDIDATE_ID),
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateCandidateOnboardingCompleteConfig = (Token: string, CANDIDATE_ID: string, DATA) => {
	return HTTP({
		Method: "POST",
		Url: CANDIDATE_ONBOARDING_COMPLETE_CONFIG(CANDIDATE_ID),
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse>;
};

export const GetCandidateStatusWorkflowConfig = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_STATUS_WORKFLOW_CONFIG,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const GetCandidateStatusWorkflowConfigOnly = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_STATUS_WORKFLOW_CONFIG_ONLY,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateCandidateStatusWorkflowConfig = (Token: string, DATA: ICandidateStatusWorkflow) => {
	return HTTP({
		Method: "POST",
		Url: CANDIDATE_STATUS_WORKFLOW_CONFIG,
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse>;
};

export const GetCandidateArchivedReasons = (Token: string) => {
	return HTTP({
		Method: "GET",
		Url: CANDIDATE_ARCHIVED_REASONS,
		Headers: HeadersAuth(Token),
	}) as Promise<IHttpResponse>;
};

export const UpdateCandidateArchivedReasons = (Token: string, DATA: ICandidateArchiveReason) => {
	return HTTP({
		Method: "PUT",
		Url: CANDIDATE_ARCHIVED_REASONS,
		Headers: HeadersAuth(Token),
		Data: DATA ?? null,
	}) as Promise<IHttpResponse>;
};
